import { Avatar, Fade, IconButton, Paper, Slide, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { Link } from 'react-router-dom';
import MensalidadeApi from '../../../api/MensalidadeApi';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import { format } from 'date-fns';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  avatar: {
    marginLeft: '20px'
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
});
class VigenciaSeguroConsulta extends React.Component {
  mensalidadeApi = new MensalidadeApi();
  state = {
    seguros: [],
    fetching: false,
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarSeguros();
    this.setState({fetching: false});
  }
  consultarSeguros = async () => {
    let seguros = await this.mensalidadeApi.consultarVigenciasSeguro();
    this.setState({seguros: seguros});
  }
  render () {
    const options = {
      print: false,
      download: false,
      selectableRows: 'none',
      filterType: 'dropdown',
      rowsPerPageOptions: [10, 20, 30],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>tipo(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Sequencial',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor Seguro',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable} style={{fontSize: 12}}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Data Início',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Data Fim',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Cod Usuario Cadastro',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nome Usuario Cadastro',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Data Cancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Motivo Cancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
    ];

    const { classes } = this.props;
    const { fetching, seguros } = this.state;
    return (
      <React.Fragment>
        <Link to='/tabelasApoio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Vigências do Seguro</Typography>
              {seguros && <Avatar className={classes.avatar}>{seguros.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={seguros}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(VigenciaSeguroConsulta);
